import { DateTime } from "luxon";
import uuid from "uuid/v1";
import {
  priceTriggerType,
  OutcomePriceType
} from "../../../api/constants/priceTriggerEnums";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { DetectMobile } from "../../../mixins/detectmobile";
export default {
  computed: {
    ...mapGetters([
      "priceTriggerOutcomes",
      "cartValue",
      "cartItems",
      "totaltax",
      "getIsDelivery",
      "discount",
      "getTotalPrice",
      "deliveryFee",
      DetectMobile.methods.isMobile() ? "mobileStyles" : "desktopStyles",
      "applicableLoyalityRule",
      "canshowRedemption",
      "storeMenu",
      "getProductInCategoryInfo",
      "useStampCollection",
      "reedemptionPoints",
      "getSurchargeAmount",
      "costlyCartItems",
      "currentStoreDoc"
    ]),
    ...mapGetters(
      !DetectMobile.methods.isMobile()
        ? ["getSelectedTriggerCheckOutPage", "getTriggerCheckOutPage"]
        : []
    ),

    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    getStamps() {
      if (this.useStampCollection) return this.reedemptionPoints;
      else return null;
    },
    getPoints() {
      if (this.getStamps != null) return null;
      if (this.applicableLoyalityRule)
        return Math.round(
          this.totalPrice * this.applicableLoyalityRule.pointPerDollar
        );
      else return null;
    },
    wholeOrderDiscount() {
      var res = this.priceTriggerOutcomes.find(
        pt => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
      );
      return res;
    },
    wholeOrderDiscountMessage() {
      var res = this.wholeOrderDiscount;
      if (res) {
        switch (res.OutcomePriceType) {
          case OutcomePriceType.OutcomePriceType_PercentageDiscount:
            return `This order will be discounted ${res.DiscountPercentageValue *
              100}%`;
          case OutcomePriceType.DiscountFlatValue:
            return `This order will be discounted ${res.DiscountPercentageValue}%`;
          default:
            return "";
        }
      }
      return "";
    },
    cartLength() {
      let sum = 0;
      this.cartItems.forEach(element => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    totalPrice() {
      return this.getTotalPrice;
    },
    subtotalPrice() {
      return this.cartValue;
    },
    showDelivery() {
      return this.getIsDelivery;
    },
    exceedMinPurchase() {
      return this.subtotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local()
        .set({ hour: 10, minute: 0, second: 0 })
        .toUTC();
    },
    now() {
      return DateTime.toUTC();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.cartItems.length === 0 ||
        this.costlyCartItems.length == 0 ||
        this.storeClosed === true ||
        !this.store.IsInOperation ||
        (!this.privacyPolicyCheckbox &&
          this.currentStoreDoc.TermsAndConditions &&
          !this.isMobile())
      );
    }
  },
  methods: {
    ...mapMutations(["REMOVE_CART_ITEM", "setDeliveryFee", "Add_ProductItem"]),
    ...mapActions([
      "insertErrorlog",
      "insertWarninglog",
      "redirectToErrorPage",
      "applyPriceTriggers",
      "fixRedemptionQuantity"
    ]),
    //desktop
    focusCart() {
      if (this.$refs.cartWrapper)
        this.$refs.cartWrapper.click();
    },
    applyCoupon(code) {
      this.$refs.couponComponent.applyCoupon(code);
    },
    selectTriggerCheckOutPageEvent(value) {
      this.setSelectedTriggerCheckOutPage(value);
      this.$forceUpdate();
    },
    //mobile
    closeQrCodeScanner() {
      this.$refs.couponComponent.closeQrCodeScanner();
    },
    goOrder() {
      this.$router.push({ name: "store", params: { storeid: this.store.ID } });
    },
    continueOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    clearAllOrders() {
      this.cartItems.forEach(cartitem => {
        this.REMOVE_CART_ITEM({ item: cartitem });
        this.applyPriceTriggers();
      });
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime)) {
        this.cartItems.forEach(element => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_CART_ITEM({ item: element });
            this.applyPriceTriggers();
          }
        });
      }
    },
    initDeliveryInfo(value) {
      //delivery fee
      if (value == 0) {
        value = this.subtotalPrice;
      }
      let _deliveryFee = 0;
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            value > rule.PriceRangeMinimum &&
            value < rule.PriceRangeMaximum
          ) {
            _deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }
      this.setDeliveryFee(_deliveryFee);
    },
    computeRules() {
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
              .MinimumTotalPrice
            : 0;
        }
      }
    },
    addReedemption() {
      var product = this.menuCopy.Products[
        this.canshowRedemption.ProductVariant
      ];
      if (product.ModifierGroups && product.ModifierGroups.length > 0) {
        this.selectedReedemption = {
          product: product,
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.canshowRedemption.ProductVariant.toString()
        };
        this.showRedemption = true;
      } else {
        this.confirmReedemption(product);
      }
    },
    closeModal() {
      this.$refs.redemptionModal.hideModal();
      this.showRedemption = false;
    },
    selectRollIntoModiefiers(modifiers) {
      if (this.selectedReedemption) {
        this.confirmReedemption(this.selectedReedemption.product, modifiers);
        this.selectedReedemption = null;
        this.$refs.redemptionModal.hideModal();
        this.showRedemption = false;
        return;
      }
    },
    confirmReedemption(product, modifiers = []) {
      var productInfo = this.getProductInCategoryInfo(
        this.canshowRedemption.ProductVariant
      );
      var newPrice =
        productInfo.Price -
        productInfo.Price * (this.canshowRedemption.DiscountRate / 100);
      this.Add_ProductItem({
        item: {
          id: this.canshowRedemption.ProductVariant,
          uniqueId: uuid(),
          itemNote: "",
          code: product.ProductCode,
          name: product.Name,
          description: product.ShortDescription,
          photoUrl: product.PhotoUrl,
          tax: product.TaxRate,
          price: newPrice,
          reedemptionRule: this.canshowRedemption,
          RewardPoint: product.RewardPoint,
          categoryId: this.productInfo && this.productInfo.categoryId ? this.productInfo.categoryId : null,
          categoryName: this.productInfo && this.productInfo.categoryName ? this.productInfo.categoryName : null
        },
        quantity: 1,
        ProductCategoryIDs: product.ProductCategoryIDs,
        ProductTagIDs: product.ProductTagIDs,
        modifiers: modifiers
      });
      this.applyPriceTriggers();
    }
  }
};
